import dynamic from 'next/dynamic'

const widgetRegistry = {
  'widget-banner-default': dynamic(() => import('./Banner/BannerDefault')),
  'widget-breadcrumb-default': dynamic(() => import('./Breadcrumb/BreadcrumbDefault')),
  'widget-article-detail-default': dynamic(() => import('./Article/ArticleDetailDefault')),
  'widget-article-detail-head': dynamic(() => import('./Article/ArticleDetailHead')),
  'widget-article-detail-head-day': dynamic(() => import('./Article/ArticleDetailHeadDay')),
  'widget-article-detail-head-item-day': dynamic(() => import('./Article/ArticleDetailHeadItemDay')),
  'widget-article-detail-footer': dynamic(() => import('./Article/ArticleDetailFooter')),
  'widget-article-detail-footer-item-day': dynamic(() => import('./Article/ArticleDetailFooterItemDay')),
  'widget-dpa-default': dynamic(() => import('./dpa/Default/DPADefault')),
  'widget-dpa-inline': dynamic(() => import('./dpa/Inline/DPAInline')),
  'widget-iframe-default': dynamic(() => import('./iFrame/Default/iFrameDefault')),
  'widget-iframe-infront': dynamic(() => import('./iFrame/InFront/iFrameInFront')),
  'widget-integration-default': dynamic(() => import('./Integration/Default/IntegrationDefault')),
  'widget-integration-sport': dynamic(() => import('./Integration/Sport/IntegrationSport')),
  'widget-integration-tv-program': dynamic(() => import('./Integration/TVProgram/IntegrationTVProgram')),
  'widget-integration-weather': dynamic(() => import('./Integration/Weather/IntegrationWeather')),
  'widget-picture-inline': dynamic(() => import('./Picture/Picture')),
  'widget-picture-inline-top': dynamic(() => import('./Picture/PictureInlineTop')),
  'widget-teaser-small': dynamic(() => import('@/elements/widgets/Teaser/Small/TeaserSmall')),
  'widget-teaser-small-inline': dynamic(() => import('@/elements/widgets/Teaser/Small/TeaserSmallInline')),
  'widget-teaser-highlight_1': dynamic(() => import('@/elements/widgets/Teaser/Highlight/_1/TeaserHighlight_1')),
  'widget-teaser-highlight_2': dynamic(() => import('@/elements/widgets/Teaser/Highlight/_2/TeaserHighlight_2')),
  'widget-teaser-highlight_3': dynamic(() => import('@/elements/widgets/Teaser/Highlight/_3/TeaserHighlight_3')),
  'widget-teaser-slider': dynamic(() => import('./Teaser/Slider/TeaserSlider')),
  'widget-teaser-infinity': dynamic(() => import('./Teaser/Infinity/TeaserInfinity')),
  'widget-teaser-inline': dynamic(() => import('@/elements/widgets/Teaser/Inline/TeaserInline')),
  'widget-gallery-default': dynamic(() => import('./Gallery/GalleryDefault')),
  'widget-gallery-inline': dynamic(() => import('./Gallery/GalleryInline')),
  'widget-gallery-inline-top': dynamic(() => import('./Gallery/GalleryInlineTop')),
  'widget-affiliate-inline': dynamic(() => import('./Affiliate/AffiliateInline')),
  'widget-external-inline': dynamic(() => import('./external/ExternalInline')),
  'widget-video-default': dynamic(() => import('./Video/VideoDefault')),
  'widget-video-inline-top': dynamic(() => import('./Video/VideoInlineTop')),
  'widget-video-inline': dynamic(() => import('./Video/VideoInline')),
  'widget-rtlplusmusic-inline': dynamic(() => import('./RTLMusic/RTLMusicInline')),
  'widget-infographic-default': dynamic(() => import('./InfoGraphic/InfoGraphicDefault')),
  'widget-infographic-inline': dynamic(() => import('./InfoGraphic/InfoGraphicInline')),
  'widget-infobox-inline': dynamic(() => import('./InfoBox/InfoBoxInline')),
  'widget-topicbox-default': dynamic(() => import('./TopicBox/TopicBox')),
  'widget-adslot-default': dynamic(() => import('./AdSlot/AdSlot')),
  'widget-adslot-ob': dynamic(() => import('./AdSlot/AdSlotOutbrain')),
  'widget-adslot-prodo': dynamic(() => import('./AdSlot/AdSlotProdo')),
  'widget-adslot-video_intxt': dynamic(() => import('./AdSlot/AdSlotVideoInTxt')),
  'widget-adslot-autonative': dynamic(() => import('./AdSlot/AdSlotAutonative')),
  'widget-title-default': dynamic(() => import('./Title/Title')),
  'widget-menu-default': dynamic(() => import('./Menu/Header/Default/MenuHeaderDefault')),
  'widget-menu-sidebar': dynamic(() => import('./Menu/Sidebar/MenuSidebarDefault')),
  'widget-menu-navigation': dynamic(() => import('./Menu/Header/Navigation/MenuHeaderNavigation')),
  'widget-menu-tab': dynamic(() => import('./Menu/Header/TabNavigation/MenuHeaderTabNavigation')),
  'widget-menu-footer': dynamic(() => import('./Menu/Footer/MenuFooter')),
  'widget-webpush-history': dynamic(() => import('./Push/History/PushHistory')),
  'widget-webpush-taglist': dynamic(() => import('./Push/TagList/PushTagList')),
}

export default widgetRegistry
